module.exports = __webpack_public_path__ + "static/img/solutionDetailPic25.6b21355.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionDetailPic25.png
// module id = vd4o
// module chunks = 1